import { compose, pure } from 'recompose'
import { Content, H2, H4, BorderedButton } from 'components/common'
import { React, Image, Link, styled, mq } from 'x'

import Arrow from 'static/svg/arrow.svg'

const Container = styled.div`
  flex: 1 1 100%;
  padding: 80px 0;
  background: #e9eaee;

  ${mq.below('xl')} {
    padding: 60px 0;
  }

  ${mq.below('sm')} {
    padding: 30px 0;
  }
`

const RelatedBlogContent = styled(Content)`
  overflow: hidden;
`

const Title = styled(H4)`
  margin-top: 20px;
  margin-bottom: 60px;
`

const BlogContainer = styled.div`
  width: calc(100% + 35px);
  display: flex;
  flex-wrap: wrap;
`

// background-size: cover;

const BlogHeader = styled.div`
  height: 200px;
  width: 100%;
  padding: 30px;
  box-sizing: border-box;

  position: relative;
`

const BlogHeaderTitle = styled(H4)`
  color: #fff;
  z-index: 2;
`

const BlogHeaderImage = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
`

const BlogContent = styled.div`
  padding: 0 38px 104px 38px;
`

const BlogHeaderGradient = styled.div`
  background: radial-gradient(
    circle at center,
    rgba(0, 0, 0, 0.2) 50%,
    transparent 140%
  );
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
`

const BlogTitle = styled(H2)`
  font-size: 35px;
  line-height: 40px;

  ${mq.below('sm')} {
    font-size: 28px;
  }
`

const BlogButton = styled(BorderedButton)`
  position: absolute;
  bottom: 38px;
  left: 38px;
  right: 38px;
  color: ${(props) => props.theme.secondary};
`

const Blog = styled(Link)`
  text-decoration: none;
  background: #fff;
  box-sizing: border-box;
  width: 364px;
  margin: 0 35px 35px 0;
  position: relative;
  box-shadow: rgba(0, 0, 0, 0.2) 0 4px 10px;
  transition: all 0.1s ease-out;

  &:hover {
    box-shadow: rgba(0, 0, 0, 0.2) 0 17px 15px;
    transform: scale(1.05) translateY(-15px);
  }
`

const enhance = compose(pure)

const RelatedBlogs = (props) => {
  if (!props.data.blogs) {
    return null
  }

  const titleElement =
    props.data.titleElement && props.data.titleElement !== 'default'
      ? props.data.titleElement
      : 'h4'

  return (
    <Container>
      <RelatedBlogContent>
        <Title as={titleElement} line={true}>
          {props.data.title}
        </Title>
        <BlogContainer>
          {props.data.blogs &&
            props.data.blogs.map((blog, index) => (
              <Blog key={index} to={props.globalData.formatLink(blog.link)}>
                <BlogHeader>
                  {blog?.acf?.image && (
                    <Image
                      fixed={blog?.acf?.image?.imgixImageWp?.fixed}
                      style={{
                        position: 'absolute',
                        top: 0,
                        right: 0,
                        bottom: 0,
                        left: 0,
                        height: 'auto',
                        width: '100%',
                      }}
                    />
                  )}
                  <BlogHeaderGradient />
                </BlogHeader>
                <BlogContent>
                  <BlogTitle>{blog.title}</BlogTitle>
                  <BlogButton as="div">
                    {props.globalData.stringReadMoreHere}
                    <Arrow className="arrow" />
                  </BlogButton>
                </BlogContent>
              </Blog>
            ))}
        </BlogContainer>
      </RelatedBlogContent>
    </Container>
  )
}

export default enhance(RelatedBlogs)
